import { createFileRoute } from "@tanstack/react-router"
import { UserRoute } from "@/app"

export const Route = createFileRoute("/(user)")({
  component: RouteComponent,
})

function RouteComponent() {
  return <UserRoute />
}
